<template>
	<el-form size="mini" ref="form" :model="form" label-width="100px" :inline="true" :show-message="false">
		<el-form-item label="序列号" style="display: block;width: 1000px !important;" class="detail_item">
			<el-input style="width: 776px !important;" readonly v-model="item.number"></el-input>
		</el-form-item>
		<el-form-item label="发票抬头" class="detail_item">
			<el-input v-model="form.invoicetitle"></el-input>
		</el-form-item>
		<el-form-item label="邮箱" class="detail_item">
			<el-input v-model="form.invoiceemail"></el-input>
		</el-form-item>
		<el-form-item label="企业税号" class="detail_item">
			<el-input v-model="form.invoicetaxid"></el-input>
		</el-form-item>
		<el-form-item label="详细地址" class="detail_item">
			<el-input style="width: 466px;" v-model="form.invoiceaddress"></el-input>
		</el-form-item>
		<el-form-item label="固话" class="detail_item">
			<el-input v-model="form.invoicephone"></el-input>
		</el-form-item>
		<el-form-item label="开户行" class="detail_item">
			<el-input v-model="form.invoicebank"></el-input>
		</el-form-item>
		<el-form-item label="银行账号" class="detail_item">
			<el-input v-model="form.invoicebankaccount"></el-input>
		</el-form-item>
<!-- 		<el-form-item style="width: 100%;margin-left: 100px;">
			<el-button :loading="loading" type="success" @click="sync">同步线上</el-button>
			<el-button type="primary" @click="onSubmit">保存</el-button>
		</el-form-item> -->
	</el-form>
</template>
<style scoped>
.detail_item{
	margin-bottom: 4px;
}
</style>
<script>
	export default {
		props: {
			item: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				loading:false,
				form: {
					invoicetitle: '',
					invoiceemail: '',
					invoicetaxid: '',
					invoiceaddress: '',
					invoicephone: '',
					invoicebank: '',
					invoicebankaccount: '',
				}

			}
		},
		watch: {

		},
		computed: {

		},
		created() {
			for (let i in this.form) {
				this.form[i] = this.item[i]
			}
		},
		mounted() {

		},
		methods: {
			sync() {
				if (this.item.ordercode != '') {
					this.loading = true
					this.$api.searchInvoiceoutput(this.item.ordercode).then((res) => {
						if (res.data.length != 0) {
							this.getItemValue(res.data[0])
						} else {
							this.submitBuff = false
							this.$message.error('未查询到订单')
						}
						this.loading = false
					})
				} else {
					this.$message.error('请填写订单编号')
				}
			},
			getItemValue(data) {
				if (data.invoice) {
					this.form.invoicetitle = data.invoice.header
					this.form.invoiceemail = data.invoice.invoice_email
					this.form.invoicetaxid = data.invoice.invoice_tax_id
					this.form.invoiceaddress = data.invoice.invoice_address
					this.form.invoicephone = data.invoice.invoice_mobile
					this.form.invoicebank = data.invoice.invoice_bank
					this.form.invoicebankaccount = data.invoice.invoice_bank_account
				}
			},
			onSubmit() {
				this.$api.updateInvoiceoutput(this.item.id, this.form).then(() => {
					this.$message({
						message: '操作成功',
						type: 'success'
					})

				})
			}
		},
		components: {

		}
	}
</script>
